module.exports = __webpack_public_path__ + "static/media/p3_7.48cbdf43.png";